<template>
    <Dialog :open="open" @update:open="handleClose">
        <DialogContent class="sm:max-w-md">
            <DialogHeader>
                <DialogTitle>
                    {{ currentKey ? 'Edit' : 'Setup' }} your OpenAI Text Assistant
                </DialogTitle>
            </DialogHeader>

            <div class="space-y-4">
                <div>
                    <Label for="openai-key">OpenAI token</Label>
                    <Input
                        id="openai-key"
                        v-model="key"
                        placeholder="Enter your OpenAI token"
                        class="mt-1.5"
                        @focus="clearMaskedKey"
                    />
                </div>

                <p class="text-sm text-muted-foreground">
                    For more information how to setup OpenAI Text Assistant
                    <a
                        href="https://docs.topol.io/guide/ai-assistant.html"
                        target="_blank"
                        class="font-semibold underline text-new-blue-500 hover:text-new-blue-600"
                    >
                        check out our documentation</a
                    >.
                </p>

                <p v-if="currentKey" class="text-sm text-muted-foreground">
                    Disable OpenAI Text Assistant by
                    <span
                        class="cursor-pointer font-semibold text-new-blue-500 hover:text-new-blue-600"
                        @click="$emit('delete')"
                    >
                        deleting your token</span
                    >.
                </p>
            </div>

            <DialogFooter class="mt-4">
                <Button size="lg" variant="ghost" @click="handleClose">
                    Cancel
                </Button>
                <Button
size="lg"
                    :disabled="!key || loading"
                    @click="handleSave"
                >
                    {{ currentKey ? 'Update token' : 'Finish setup' }}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const props = defineProps<{
    open: boolean;
    currentKey: string;
}>();

const emit = defineEmits<{
    close: [];
    save: [key: string];
    delete: [];
    'update:open': [value: boolean];
}>();

const key = ref(props.currentKey || '');
const loading = ref(false);

watch(
    () => props.open,
    (newValue) => {
        if (newValue) {
            key.value = props.currentKey || '';
            loading.value = false;
        }
    }
);

// The key is prefilled with a masked placeholder (contains •); clear it on
// focus so the user types a fresh value instead of appending to the mask.
const clearMaskedKey = () => {
    if (key.value.includes('•')) {
        key.value = '';
    }
};

const handleClose = () => {
    emit('close');
    emit('update:open', false);
};

const handleSave = () => {
    if (key.value) {
        loading.value = true;
        emit('save', key.value);
    }
};
</script>
